import { useEffect, useState, useRef } from "react";
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";
import { Checkbox } from "@gpstrackit/react-controls";

//Components
import { Modal, ModalBody, ModalFooter, Button, Form, Input } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';
import { Select } from "@gpstrackit/react-controls";
import { Alert } from '@mui/material';
//Actions
import {
    clearRedux,
    templateCreateRequest,
    templateUpdateRequest,
    templateSearchRequest,
} from 'Redux/actions';

const CreateEditTemplate = (props) => {
    const { selectedTemplate, language, html, setCurrentTemplate } = props

    const { messages } = useIntl();
    const dispatch = useDispatch();
    const formRef = useRef(null)

    const [name, setName] = useState("");
    const [currentLanguage, setCurrentLanguage] = useState(null);
    const [newTemplate, setNewTemplate] = useState(false);

    const { openModal, loading, create, update } = useSelector(state => state.createEditTemplateRedux);

    const closeModal = () => {
        dispatch(clearRedux("TEMPLATES"))
        setName("");
        setCurrentLanguage(null);
        setNewTemplate(false);
    }

    const saveTemplate = () => {
        let payload = {
            name,
            moduleCode: "login-page",
            language: currentLanguage?.id === 1 ? 'EN' : 'ES',
            html,
            dealerId: 1
        }

        if (!selectedTemplate || newTemplate) {
            dispatch(templateCreateRequest(payload))
        } else {
            payload.id = +selectedTemplate.id
            dispatch(templateUpdateRequest(payload))
        }
    }

    useEffect(() => {
        if (openModal && selectedTemplate) {
            setName(selectedTemplate?.name)
        }
    }, [openModal])

    useEffect(() => {
        if (create?.id) {
            NotificationManager.success(
                messages['create_template_create_message'],
                messages['create_template_create'],
                3000
            );
            closeModal();
            dispatch(templateSearchRequest(language?.id))
            dispatch(clearRedux("TEMPLATES", { create: null }))
            setCurrentTemplate(false);
        }
        if (create?.error) {
            NotificationManager.error(
                messages['create_template_same_name'],
                messages['create_template_create'],
                3000
            );
            dispatch(clearRedux("TEMPLATES", { create: null }))
        }
        if (update?.id) {
            NotificationManager.success(
                messages['create_template_edit_message'],
                messages['create_template_edit'],
                3000
            );
            closeModal();
            dispatch(templateSearchRequest(language?.id))
            dispatch(clearRedux("TEMPLATES", { update: null }));
            setCurrentTemplate(false);
        }
        if (update?.error) {
            NotificationManager.error(
                messages['create_template_same_name'],
                messages['create_template_edit'],
                3000
            );
            dispatch(clearRedux("TEMPLATES", { update: null }))
        }
    }, [create, update])

    useEffect(() => {
        if (openModal) {
            if (language) {
                setCurrentLanguage(language);
            }
        }
    }, [openModal])

    let content = html === "<p><br></p>" ? null : html

    return (
        <Modal
            open={openModal}
            title={selectedTemplate ? `${messages['create_template_edit']} (${selectedTemplate?.name})` : messages['create_template_create']}
            loading={loading}
            position="right"
            size="small"
            handleClose={closeModal}
        >
            <ModalBody>
                <div style={{ padding: '0 10px', marginBottom: 30 }}>
                    <Form
                        ref={formRef}
                        onValidSubmit={() => saveTemplate()}
                    >
                        <div>
                            <Input
                                label={messages['create_template_name']}
                                placeholder={messages['create_template_name']}
                                onChange={setName}
                                value={name}
                                required
                            />
                        </div>
                        <div style={{ marginTop: 10 }}>
                            <Select
                                id="languante-template"
                                label={messages['create_template_language']}
                                textField="label"
                                valueField="id"
                                options={[
                                    {
                                        id: 1,
                                        label: "English"
                                    },
                                    {
                                        id: 2,
                                        label: "Español"
                                    }
                                ]}
                                value={currentLanguage}
                                onChange={setCurrentLanguage}
                                required
                            />
                        </div>
                        {
                            selectedTemplate && (
                                <Checkbox
                                    id="update-feature-show"
                                    label={messages['create_template_save_new_template']}
                                    value={newTemplate}
                                    onChange={(checked) => setNewTemplate(checked)}
                                />
                            )
                        }
                    </Form>
                    {
                        !content && (
                            <Alert
                                style={{ marginTop: 10 }}
                                severity="info"
                            >
                                {messages['create_template_no_changes_to_save']}
                            </Alert>
                        )
                    }
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['close']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => formRef?.current?.submit()}
                    disabled={!content}
                >
                    {messages['create_template_save']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default CreateEditTemplate;